// extracted by mini-css-extract-plugin
module.exports = {"ratingLink":"Rating_ratingLink__wPEYB","sm":"Rating_sm__GsAGY","ratingAndReviews":"Rating_ratingAndReviews__Qnq1x"};